import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './our-footprint.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var OurFootprint = /** @class */ (function (_super) {
    tslib_1.__extends(OurFootprint, _super);
    function OurFootprint(element) {
        var _this = _super.call(this, element) || this;
        // json
        _this.json = [];
        _this.defaultCountry = '';
        return _this;
    }
    OurFootprint.prototype.init = function () {
        var _this = this;
        // country selector
        this.countrySelectorButton = this.element.querySelector('.our-footprint__dropdown');
        this.countrySelectorModalContainer = this.element.querySelector('.our-footprint__modal');
        window.addEventListener('resize', function (event) {
            var globeViz = _this.mapContainer.querySelector('#globeViz');
            _this.globe.width(globeViz.clientWidth);
            _this.globe.height(globeViz.clientWidth);
            // this.globe.width(this.mapContainer.clientWidth);
            // this.globe.height(this.mapContainer.clientWidth);
        });
        // detect default country
        var indexDefault = 0;
        var indexDefaultDetect = 0;
        if (this.element.getAttribute('data-country')) {
            this.defaultCountry = this.element.getAttribute('data-country');
            jsonOurFootprint.forEach(function (object) {
                if (object.name === _this.defaultCountry) {
                    indexDefault = indexDefaultDetect;
                }
                indexDefaultDetect++;
            });
        }
        // populate
        this.populateContent(indexDefault, this.element);
        this.populateCountrySelector();
        // globe
        this.globeDataJson = [];
        var indexGlobe = 0;
        jsonOurFootprint.forEach(function (object) {
            var empty = {
                content: {
                    index: indexGlobe,
                    flag: object.icon + '.svg',
                    flagFilename: object.icon,
                    name: object.name,
                    description: object.description
                },
                lat: object.latitude,
                lng: object.longitude,
                size: 19,
                color: 'green'
            };
            _this.globeDataJson.push(empty);
            indexGlobe++;
        });
        this.mapContainer = this.element.querySelector('.our-footprint__map');
        this.globe = Globe();
        this.createGlobe(this.element);
    };
    OurFootprint.prototype.bindEvents = function () {
        var _this = this;
        $(document).on("click", "a.our-footprint__countries__section-country", function (event) {
            var element = undefined;
            if (event.currentTarget) {
                element = event.currentTarget;
            }
            else {
                element = event.target;
            }
            $('.our-footprint__modal').removeClass('our-footprint__modal--active');
            $('.our-footprint__countries__modal').addClass('country-selector__modal--disappear');
            setTimeout(function () {
                $('.our-footprint__countries__modal').removeClass('our-footprint__countries__modal--reveal').removeClass('our-footprint__countries__modal--disappear');
            }, 400);
            var getIndex = parseInt(element.getAttribute('data-index'));
            // this.populateContent(getIndex, this.element);
            _this.goToPoint(getIndex, _this.element);
        });
    };
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    // POPULATE
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    OurFootprint.prototype.populateContent = function (index, element) {
        if (index === void 0) { index = 0; }
        if (element === void 0) { element = undefined; }
        var json = jsonOurFootprint;
        if (json.length > 0) {
            //////////////////////////////////////
            // populate content
            //////////////////////////////////////
            var detailName = element.querySelector('.js-detail-name');
            var detailLink = element.querySelector('.js-detail-link');
            var detailDescription = element.querySelector('.js-detail-description');
            var detailChips = element.querySelector('.js-detail-chips');
            var detailCards = element.querySelector('.js-detail-cards');
            var buttonText = element.querySelector('.our-footprint__dropdown--country');
            var buttonFlag = element.querySelector('.our-footprint__dropdown--flag');
            detailName.innerHTML = '';
            detailLink.innerHTML = '';
            detailDescription.innerHTML = '';
            detailChips.innerHTML = '';
            detailCards.innerHTML = '';
            buttonText.innerHTML = '';
            var firstItem_1 = true;
            var outputChips_1 = "";
            var outputCards_1 = "";
            if (json[index].icon) {
                buttonFlag.innerHTML = "<i data-component=\"icon\" data-icon=\"" + json[index].icon + "\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon js-footprint-icon\"></i>";
            }
            if (json[index].name) {
                detailName.innerHTML = json[index].name;
                buttonText.innerHTML = json[index].name;
            }
            if (json[index].link) {
                detailLink.innerHTML = "<a href=\"" + json[index].link + "\" target=\"_blank\" class=\"link\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + json[index].name + " | View country website | link click\"><span class=\"link__text\">View Country website</span></a>";
            }
            if (json[index].description) {
                detailDescription.innerHTML = json[index].description;
            }
            // if(json[index].deals) {
            // 	if(json[index].deals.length > 0) {
            // 		outputChips += `<a href="javascript:void(0)" class="our-footprint__content--chips__chip ${ firstItem ? 'active' : '' }" data-type="deals">Deals</a>`;
            // 		outputCards += `<div class="our-footprint__content--cards ${ firstItem ? '' : 'd-none' } js-detail-card" data-type="deals">`;
            // 		json[index].deals.forEach((deal: any) => {
            // 			let outputImage: any = ``;
            // 			if(deal.images) {
            // 				outputImage = `<div class="our-footprint__content--card__image">
            // 					<picture>
            // 						<source srcset="${deal.images.desktop}" 
            // 							media="(min-width: 1024px)">
            // 						<source srcset="{${deal.images.tablet}" 
            // 							media="(min-width: 768px)">
            // 						<img class="responsive-image"
            // 							src="${deal.images.desktop}" 
            // 							srcset="${deal.images.mobile}" 
            // 							alt="${deal.name}">
            // 					</picture>
            // 				</div>`;
            // 			}
            // 			outputCards += `<div class="our-footprint__content--card">	
            // 				<div class="our-footprint__content--card__content">	
            // 					<div class="our-footprint__content--card__content--title">	
            // 						<div class="title title--entrance">
            // 							${deal.title}
            // 						</div>	
            // 					</div>	
            // 					<div class="our-footprint__content--card__content--link">	
            // 						<a href="${deal.link}" class="link">	
            // 							<span class="link__text">	
            // 								${deal.linkText}
            // 							</span>	
            // 						</a>	
            // 					</div>	
            // 				</div>	
            // 				${outputImage}
            // 			</div>`;
            // 		});
            // 		outputCards += `</div>`;
            // 		firstItem = false;
            // 	}
            // }
            // if(json[index].news) {
            // 	if(json[index].news.length > 0) {
            // 		outputChips += `<a href="javascript:void(0)" class="our-footprint__content--chips__chip ${ firstItem ? 'active' : '' }" data-type="news">News</a>`;
            // 		outputCards += `<div class="our-footprint__content--cards ${ firstItem ? '' : 'd-none' } js-detail-card" data-type="news">`;
            // 		json[index].news.forEach((deal: any) => {
            // 			let outputImage: any = ``;
            // 			if(deal.images) {
            // 				outputImage = `<div class="our-footprint__content--card__image">
            // 					<picture>
            // 						<source srcset="${deal.images.desktop}" 
            // 							media="(min-width: 1024px)">
            // 						<source srcset="{${deal.images.tablet}" 
            // 							media="(min-width: 768px)">
            // 						<img class="responsive-image"
            // 							src="${deal.images.desktop}" 
            // 							srcset="${deal.images.mobile}" 
            // 							alt="${deal.name}">
            // 					</picture>
            // 				</div>`;
            // 			}
            // 			outputCards += `<div class="our-footprint__content--card">	
            // 				<div class="our-footprint__content--card__content">	
            // 					<div class="our-footprint__content--card__content--title">	
            // 						<div class="title title--entrance">
            // 							${deal.title}
            // 						</div>	
            // 					</div>	
            // 					<div class="our-footprint__content--card__content--link">	
            // 						<a href="${deal.link}" class="link">	
            // 							<span class="link__text">	
            // 								${deal.linkText}
            // 							</span>	
            // 						</a>	
            // 					</div>	
            // 				</div>	
            // 				${outputImage}								
            // 			</div>`;
            // 		});
            // 		outputCards += `</div>`;
            // 		firstItem = false;
            // 	}
            // }
            // if(json[index].campaigns) {
            // 	if(json[index].campaigns.length > 0) {
            // 		outputChips += `<a href="javascript:void(0)" class="our-footprint__content--chips__chip ${ firstItem ? 'active' : '' }" data-type="campaigns">Campaigns</a>`;
            // 		outputCards += `<div class="our-footprint__content--cards ${ firstItem ? '' : 'd-none' } js-detail-card" data-type="campaigns">`;
            // 		json[index].campaigns.forEach((deal: any) => {
            // 			let outputImage: any = ``;
            // 			if(deal.images) {
            // 				outputImage = `<div class="our-footprint__content--card__image">
            // 					<picture>
            // 						<source srcset="${deal.images.desktop}" 
            // 							media="(min-width: 1024px)">
            // 						<source srcset="{${deal.images.tablet}" 
            // 							media="(min-width: 768px)">
            // 						<img class="responsive-image"
            // 							src="${deal.images.desktop}" 
            // 							srcset="${deal.images.mobile}" 
            // 							alt="${deal.name}">
            // 					</picture>
            // 				</div>`;
            // 			}
            // 			outputCards += `<div class="our-footprint__content--card">	
            // 				<div class="our-footprint__content--card__content">	
            // 					<div class="our-footprint__content--card__content--title">	
            // 						<div class="title title--entrance">
            // 							${deal.title}
            // 						</div>	
            // 					</div>	
            // 					<div class="our-footprint__content--card__content--link">	
            // 						<a href="${deal.link}" class="link">	
            // 							<span class="link__text">	
            // 								${deal.linkText}
            // 							</span>	
            // 						</a>	
            // 					</div>	
            // 				</div>	
            // 				${outputImage}									
            // 			</div>`;
            // 		});
            // 		outputCards += `</div>`;
            // 		firstItem = false;
            // 	}
            // }
            var objectKeys = Object.keys(json[index]);
            objectKeys.forEach(function (key) {
                if (key !== 'contacts') {
                    if (Array.isArray(json[index][key])) {
                        var type = key.toLowerCase();
                        var name_1 = type.charAt(0).toUpperCase() + type.slice(1);
                        outputChips_1 += "<a href=\"javascript:void(0)\" class=\"our-footprint__content--chips__chip " + (firstItem_1 ? 'active' : '') + "\" data-type=\"" + type + "\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + json[index].name + " | " + name_1 + " | link click\">" + name_1 + "</a>";
                        outputCards_1 += "<div class=\"our-footprint__content--cards " + (firstItem_1 ? '' : 'd-none') + " js-detail-card\" data-type=\"" + type + "\">";
                        json[index][key].forEach(function (item) {
                            var outputImage = "";
                            if (item.images) {
                                if (item.images.desktop) {
                                    outputImage = "<div class=\"our-footprint__content--card__image\">\n\t\t\t\t\t\t\t\t\t\t<picture>\n\t\t\t\t\t\t\t\t\t\t\t<source srcset=\"" + item.images.desktop + "\" \n\t\t\t\t\t\t\t\t\t\t\t\tmedia=\"(min-width: 1024px)\">\n\t\t\t\t\t\t\t\t\t\t\t<source srcset=\"" + item.images.tablet + "\" \n\t\t\t\t\t\t\t\t\t\t\t\tmedia=\"(min-width: 768px)\">\n\t\t\t\t\t\t\t\t\t\t\t<img class=\"responsive-image\"\n\t\t\t\t\t\t\t\t\t\t\t\tsrc=\"" + item.images.desktop + "\" \n\t\t\t\t\t\t\t\t\t\t\t\tsrcset=\"" + item.images.mobile + "\" \n\t\t\t\t\t\t\t\t\t\t\t\talt=\"" + item.name + "\">\n\t\t\t\t\t\t\t\t\t\t</picture>\n\t\t\t\t\t\t\t\t\t</div>";
                                }
                            }
                            outputCards_1 += "<div class=\"our-footprint__content--card\">\t\n\t\t\t\t\t\t\t\t<div class=\"our-footprint__content--card__content\">\t\n\t\t\t\t\t\t\t\t\t<div class=\"our-footprint__content--card__content--title\">\t\n\t\t\t\t\t\t\t\t\t\t<a href=\"" + item.link + "\" class=\"title title--entrance\">\n\t\t\t\t\t\t\t\t\t\t\t" + item.title + "\n\t\t\t\t\t\t\t\t\t\t</a>\t\n\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t\t<div class=\"our-footprint__content--card__content--link\">\t\n\t\t\t\t\t\t\t\t\t\t<a href=\"" + item.link + "\" class=\"link\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + json[index].name + " | " + name_1 + " | " + item.title + " | Read more link click\">\t\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"link__text\">\t\n\t\t\t\t\t\t\t\t\t\t\t\t" + item.linkText + "\n\t\t\t\t\t\t\t\t\t\t\t</span>\t\n\t\t\t\t\t\t\t\t\t\t</a>\t\n\t\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t\t" + outputImage + "\n\t\t\t\t\t\t\t</div>";
                        });
                        outputCards_1 += "</div>";
                        firstItem_1 = false;
                    }
                }
            });
            if (json[index].contacts) {
                if (json[index].contacts.length > 0) {
                    outputChips_1 += "<a href=\"javascript:void(0)\" class=\"our-footprint__content--chips__chip " + (firstItem_1 ? 'active' : '') + "\" data-type=\"contacts\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + json[index].name + " | Contacts | link click\">Contact</a>";
                    outputCards_1 += "<div class=\"our-footprint__content--cards " + (firstItem_1 ? '' : 'd-none') + " js-detail-card\" data-type=\"contacts\">";
                    json[index].contacts.forEach(function (contact) {
                        var outputCardAddress = "";
                        var outputCardPhone = "";
                        var outputCardEmail = "";
                        if (contact.address) {
                            outputCardAddress = "<div class=\"row\">   \n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-md-4\">    \n\t\t\t\t\t\t\t\t\tAddress:    \n\t\t\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-md-8\">\n\t\t\t\t\t\t\t\t\t" + contact.address + "\n\t\t\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t\t</div>";
                        }
                        if (contact.phone) {
                            outputCardPhone = "<div class=\"row\">     \n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-md-4\">    \n\t\t\t\t\t\t\t\t\tPhone:    \n\t\t\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-md-8\">\n\t\t\t\t\t\t\t\t\t<a href=\"tel:" + contact.phone + "\" class=\"title title--number-sml contact-us-item__title contact-us-item__title--number-sml\">                                                \n\t\t\t\t\t\t\t\t\t\t" + contact.phone + "\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t</div>";
                        }
                        if (contact.email) {
                            outputCardEmail = "<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-lg-4\">\n\t\t\t\t\t\t\t\t\tEmail us\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col col-12 col-lg-8\">\n\t\t\t\t\t\t\t\t\t<a href=\"mailto:" + contact.email + "\" class=\"contact-us-item__email\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + json[index].name + " | Contacts | email us | " + contact.email + " click\">\n\t\t\t\t\t\t\t\t\t\t" + contact.email + "\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>";
                        }
                        outputCards_1 += "<div class=\"row\" style=\"margin-bottom: 30px;\">\n\t\t\t\t\t\t\t<div class=\"col-lg-12\">\n\t\t\t\t\t\t\t\t" + outputCardAddress + "\n\t\t\t\t\t\t\t\t" + outputCardPhone + "\n\t\t\t\t\t\t\t\t" + outputCardEmail + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>";
                    });
                    outputCards_1 += "</div>";
                    firstItem_1 = false;
                }
            }
            detailChips.innerHTML = outputChips_1;
            detailCards.innerHTML = outputCards_1;
            //////////////////////////////////////
            // containers + triggers
            //////////////////////////////////////
            var detailChipsAll_1 = Array.from(element.querySelectorAll('.our-footprint__content--chips__chip'));
            var detailCardsAll_1 = Array.from(element.querySelectorAll('.our-footprint__content--cards'));
            detailChipsAll_1.map(function (item) { return item.addEventListener('click', function (event) {
                var elementChip = undefined;
                if (event.target) {
                    elementChip = event.target;
                }
                var category = elementChip.getAttribute('data-type');
                detailCardsAll_1.map(function (item) {
                    if (item.getAttribute('data-type') === category) {
                        item.classList.remove('d-none');
                    }
                    else {
                        item.classList.add('d-none');
                    }
                });
                detailChipsAll_1.map(function (item) {
                    item.classList.remove('active');
                });
                elementChip.classList.add('active');
            }); });
            //////////////////////////////////////
            // setup icons
            //////////////////////////////////////
            this.setupIcons();
        }
    };
    OurFootprint.prototype.populateCountrySelector = function () {
        var json = jsonOurFootprint;
        var sections = _.chain(json).groupBy("section").map(function (value, key) { return ({ section: key, countries: value }); }).value();
        var countrySelectorModalContainerContent = this.countrySelectorModalContainer.querySelector('.container');
        var indexCountry = 0;
        sections.forEach(function (section) {
            var outputCountries = "";
            section.countries.forEach(function (country) {
                outputCountries += "<a href=\"javascript:void(0)\" class=\"our-footprint__countries__section-country\" data-country=\"" + country.name + "\" data-section=\"" + section.section + "\" data-index=\"" + indexCountry + "\" data-scope=\"footprint\" data-intent=\"informational\" data-id=\"link_content\" data-text=\"" + country.name + " | country dropdown selector | link click\">\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"" + country.icon + "\" data-gradient=\"\" data-path=\"/file_source/assets/icons/\" class=\"icon js-footprint-icon\"></i>\n\t\t\t\t\t<span>" + country.name + "</span>\n\t\t\t\t</a>";
                indexCountry++;
            });
            var outputSection = "<div class=\"our-footprint__countries__section\" data-section=\"" + section.section + "\">\n\t\t\t\t<span class=\"title title--entrance\">\n\t\t\t\t\t" + section.section + "\n\t\t\t\t</span>\n\t\t\t\t<div class=\"our-footprint__countries__section-content\">\n\t\t\t\t\t" + outputCountries + "\n\t\t\t\t</div>\n\t\t\t</div>";
            var docfragmentSection = document.createDocumentFragment();
            docfragmentSection.appendChild(document.createRange().createContextualFragment(outputSection));
            countrySelectorModalContainerContent.appendChild(docfragmentSection);
        });
        this.countries = Array.from(document.querySelectorAll('.our-footprint__countries__section-country'));
        this.setupCountrySelector();
        this.setupCountrySelectorBindEvents();
        this.setupIcons();
    };
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    // COUNTRY SELECTOR
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    OurFootprint.prototype.setupCountrySelector = function () {
        var _this = this;
        if (this.element.querySelector('.our-footprint__countries')) {
            this.countrySelector = this.element.querySelector('.our-footprint__countries');
        }
        if (this.element.querySelector('.our-footprint__countries__close')) {
            this.countrySelectorCloseButton = this.element.querySelector('.our-footprint__countries__close');
        }
        this.countries = [];
        $('.our-footprint__countries__section-country').each(function (index, el) {
            _this.countries.push({ country: $(el).data('country'), section: $(el).data('section'), element: $(el) });
        });
    };
    OurFootprint.prototype.setupCountrySelectorBindEvents = function () {
        var _this = this;
        this.countrySelectorButton.addEventListener('click', function (e) {
            _this.countrySelectorModalContainer.classList.add('our-footprint__modal--active');
            if (_this.countrySelector) {
                _this.countrySelector.classList.add('our-footprint__countries__modal--reveal');
            }
        });
        if (this.countrySelectorCloseButton) {
            this.countrySelectorCloseButton.addEventListener('click', function (e) {
                _this.countrySelectorModalContainer.classList.remove('our-footprint__modal--active');
            });
        }
        $('.our-footprint__countries__close').click(function () {
            $('.our-footprint__countries__modal').addClass('country-selector__modal--disappear');
            setTimeout(function () {
                $('.our-footprint__countries__modal').removeClass('our-footprint__countries__modal--reveal').removeClass('our-footprint__countries__modal--disappear');
            }, 400);
        });
        $('.our-footprint__countries__search-input').keyup(function () {
            var searchParam = $('.our-footprint__countries__search-input').val().toLowerCase();
            if (searchParam.length > 0) {
                $('.our-footprint__countries__section').hide();
                $('.our-footprint__countries__section-country').hide();
                _this.countries.filter(function (item, index) {
                    return item.country.toLowerCase().indexOf(searchParam) > -1;
                }).forEach(function (country) {
                    country.element.show();
                    $(".our-footprint__countries__section[data-section='" + country.section + "']").show();
                });
            }
            else {
                _this.countries.forEach(function (country) {
                    country.element.show();
                    $(".our-footprint__countries__section").show();
                });
            }
        });
    };
    OurFootprint.prototype.setupIcons = function () {
        var _this = this;
        var icons = Array.from(document.querySelectorAll('.js-footprint-icon'));
        icons.forEach(function (icon) {
            var dataIcon = icon.getAttribute('data-icon');
            _this.getIcon(icon, dataIcon);
        });
    };
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    // GLOBE
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    OurFootprint.prototype.createGlobe = function (elementParent) {
        var _this = this;
        if (elementParent === void 0) { elementParent = undefined; }
        var globeViz = this.mapContainer.querySelector('#globeViz');
        this.globe.width(globeViz.clientWidth);
        this.globe.height(globeViz.clientWidth);
        this.globe.backgroundColor('#FFFFFF');
        // this.globe.globeImageUrl('//unpkg.com/three-globe/example/img/earth-dark.jpg');
        // this.globe.globeImageUrl('//unpkg.com/three-globe/example/img/earth-blue-marble.jpg');
        this.globe.globeImageUrl('/file_source/assets/img/globe.jpg');
        // this.globe.globeImageUrl('https://unpkg.com/three-globe@2.31.1/example/img/earth-night.jpg');
        this.globe.bumpImageUrl('//unpkg.com/three-globe/example/img/earth-topology.png');
        this.globe.htmlElementsData(this.globeDataJson);
        this.globe.htmlElement(function (d) {
            var el = document.createElement('div');
            el.classList.add('js-globe');
            el.setAttribute('data-country', d.content.name);
            el.innerHTML = "<div class=\"our-footprint__map--icon\">\n\t\t\t\t<svg width=\"19\" height=\"18\" viewBox=\"0 0 19 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t<circle cx=\"9.5\" cy=\"9\" r=\"8.5\" stroke=\"white\"/>\n\t\t\t\t\t<circle cx=\"9.5\" cy=\"9\" r=\"5\" fill=\"white\"/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t\t<div class=\"our-footprint__map--tooltip\">\n\t\t\t\t" + d.content.name + "\n\t\t\t</div>";
            el.style.color = d.color;
            // el.style.width = `${d.size}px`;
            // el.style.height = `${d.size}px`;
            el.style['pointer-events'] = 'auto';
            el.style.cursor = 'pointer';
            // const marker = document.createElement('div');
            // marker.classList.add('js-globe-marker');
            // const markerFlag = document.createElement('div');
            // markerFlag.classList.add('js-globe-marker-flag');
            // markerFlag.innerHTML = `<i data-component="icon" data-icon="${d.content.flagFilename}" data-gradient="" data-path="/file_source/assets/icons/" class="icon js-footprint-icon"></i>`;
            // marker.appendChild(markerFlag);
            // el.appendChild(marker);
            el.onclick = function () {
                _this.goToPoint(d.content.index, elementParent);
            };
            return el;
        });
        // Auto-rotate
        // this.globe.controls().autoRotate = true;
        // this.globe.controls().autoRotateSpeed = 0.35;
        // init
        this.globe.pointOfView({ lat: 6.554748, lng: 23.109374, altitude: 1.8 }, 1000);
        this.globe(document.getElementById('globeViz'));
    };
    OurFootprint.prototype.goToPoint = function (index, elementParent) {
        var _this = this;
        if (index === void 0) { index = 0; }
        if (elementParent === void 0) { elementParent = undefined; }
        var arrayGlobeIcons = Array.from(document.querySelectorAll('div.js-globe'));
        arrayGlobeIcons.forEach(function (arrayGlobeIcon) {
            arrayGlobeIcon.classList.remove('js-globe-active');
            var countryAttribute = arrayGlobeIcon.getAttribute('data-country');
            if (countryAttribute === _this.globeDataJson[index].content.name) {
                arrayGlobeIcon.classList.add('js-globe-active');
            }
        });
        var lat = this.globeDataJson[index].lat;
        var lng = this.globeDataJson[index].lng;
        this.globe.pointOfView({ lat: lat, lng: lng, altitude: 1.8 }, 1000);
        this.populateContent(index, elementParent);
    };
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    // ICON
    //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////
    OurFootprint.prototype.getIcon = function (container, icon) {
        if (container === void 0) { container = undefined; }
        if (icon === void 0) { icon = ''; }
        var parser = new DOMParser();
        var serializer = new XMLSerializer();
        var path = '/file_source/assets/icons/';
        this.http.get("" + path + icon + ".svg").then(function (response) {
            container.innerHTML = response.data;
        });
    };
    return OurFootprint;
}(Base));
export { OurFootprint };



//////////////////
// WEBPACK FOOTER
// ./components/our-footprint/our-footprint.component.ts
// module id = 770
// module chunks = 0